import React from 'react'

const SearchIconThin = () => (
    <svg 
        className="search-svg"
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 14.47 14.47"
    >
        <g>
            <path 
                d="M14.47,13.76l-4.13-4.13c.89-1.06,1.38-2.38,1.38-3.77,0-1.57-.61-3.04-1.72-4.14-1.11-1.11-2.58-1.72-4.14-1.72S2.82.61,1.72,1.72C.61,2.82,0,4.29,0,5.86s.61,3.04,1.72,4.14c1.11,1.11,2.58,1.72,4.14,1.72,1.4,0,2.72-.49,3.77-1.38l4.13,4.13.71-.71ZM2.42,9.3c-.92-.92-1.42-2.14-1.42-3.44s.51-2.52,1.42-3.44c.92-.92,2.14-1.42,3.44-1.42s2.52.51,3.44,1.42c.92.92,1.42,2.14,1.42,3.44s-.51,2.52-1.42,3.44-2.14,1.42-3.44,1.42-2.52-.51-3.44-1.42Z" 
                // style={{
                //     fill: '#fff'
                // }}
            />
        </g>
    </svg>
)

export default SearchIconThin